<template lang="pug">
.print-labels
  .print-layout1.left(:style="`width:${dataForm.containerWidth}`")
    .fix.line(v-for="(size, index) in sizes")
      .margin-left(v-if="((index + 3 ) % 3) === 0" :style="`width:${dataForm.padding}; height: ${dataForm.height}`")
      .margin-left(v-if="((index + 3 ) % 3) === 0" :style="`width:${dataForm.padding}; height: ${dataForm.height}`")
      .label-code(:style="buildStyleShape(dataForm.width, dataForm.height)")
        .shape-label(v-for="(shape, index) in dataForm.shapes" :style="buildStyleShape(shape.width, shape.height, shape.top, shape.left)")

        .code-label.left(v-for="(qrcode, index) in dataForm.qrcodes" :style="buildStyleString('', '', qrcode.top, qrcode.left, qrcode.degrees)")
          QRCode(:text="replaceVariables(qrcode.text, size.value, size.index)" :width="qrcode.width")

        .string-label.center.uppercase(v-for="(string, index) in dataForm.strings" :style="buildStyleString(string.width, string.height, string.top, string.left, string.degrees, string.bold)" :class="{dark: string.bold}") {{ replaceVariables(string.text, size.value, size.index) }}

        .code-label.left(v-for="(code, index) in dataForm.codes" :style="buildStyleString(code.width, code.height, code.top, code.left, code.degrees)")
          .font-128 {{ code128(replaceVariables(code.text, size.value, size.index)) }}

        img.image-label(v-for="(image, index) in dataForm.images" :src="`${imagePath}/${image.folder}/${image.name}`" :alt="image.name" :style="buildStyleShape(image.width, image.height, image.top, image.left, image.degrees)")

      .space-between(v-if="((index + 1 + 3 ) % 3) !== 0" :style="`width:${dataForm.spaceBetween}; height: ${dataForm.height}`")

      .page-break-after(v-if="((index + 1 ) % 3) === 0")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import QRCode from '@/components/elements/QRCode'

export default {
  name: 'PrintLabels',

  mixins: [mForm, mFilters],

  components: { QRCode },

  data () {
    return {
      dataForm: {
      },
      products: [],
      sizes: []
    }
  },

  mounted () {
    this.dataForm = this.$store.state.print.label
    this.products = this.$store.state.print.products
    this.setSizes()
    this.setPageSize()
  },

  methods: {
    setSizes () {
      this.products.forEach((product, index) => {
        const sizes = product.sizes
        if (!sizes) return
        const keysSizes = Object.keys(sizes)

        const sizesArray = keysSizes.reduce((arrayAcumulator, currentValue) => {
          const array = Array(sizes[currentValue]).fill({ value: currentValue, index })
          return arrayAcumulator.concat(array)
        }, [])

        this.sizes = this.sizes.concat(sizesArray)
      })
    },

    getVariables (value, size) {
      if (!value) return value
      const splitLeft = value.split('{{')
      const arrayRight = splitLeft.map(val => val.split('}}'))

      const filtered = arrayRight.filter(array => {
        if (array[0]) return array[0]
      })

      const variables = filtered.map(array => array[0])

      return variables
    },

    replaceVariables (value, size, index) {
      const variables = this.getVariables(value)
      const product = this.products[index]
      return variables.reduce((string, currentVariable) => {
        const variableToReplace = product[currentVariable] || size
        return string.replace(`{{${currentVariable}}}`, variableToReplace)
      }, value)
    },

    setPageSize () {
      const style = document.createElement('style')
      style.innerHTML = `@page {size: ${this.dataForm.containerWidth} ${this.dataForm.height}}`
      document.head.appendChild(style)
    },

    buildStyleShape (width, height, top, left, degrees) {
      const style = {
        width: width ? `width:${width};` : '',
        height: height ? `height:${height};` : '',
        top: top ? `top:${top};` : '',
        left: left ? `left:${left};` : '',
        degrees: degrees ? `transform: rotate(${degrees});` : ''
      }

      return `${style.width}${style.height}${style.top}${style.left}${style.degrees}`
    },

    buildStyleString (width, height, top, left, degrees, bold) {
      const style = {
        width: width ? `width:${width};` : '',
        height: height ? `font-size:${height};` : '',
        top: top ? `top:${top};` : '',
        left: left ? `left:${left};` : '',
        bold: bold ? `font-weight:700;` : '',
        degrees: degrees ? `transform: rotate(${degrees});` : ''
      }

      return `${style.width}${style.height}${style.top}${style.left}${style.degrees}`
    }
  }
}
</script>

<style lang="stylus">
.print-labels
  position relative

.add-panel
  display flex
  justify-content space-between
  align-items center

.label-code
  background-color white
  display inline-block
  position relative
  overflow hidden
  margin 0

.fix
  margin 1mm 0
  break-inside avoid

.shape-label
  background-color black
  position absolute
  transform-origin top left

.string-label
  color black
  position absolute
  text-align center
  white-space nowrap
  transform-origin top left

.code-label
  color black
  position absolute
  white-space nowrap
  transform-origin top left

.image-label
  position absolute
  box-sizing initial
  transform-origin top left

.space-between, .margin-left
  display inline-block

@media print
  .container, body
    padding 0
    margin 0
    background-color white

  .print-layout1
    background-color white

  .fix
    margin 0
    break-inside avoid
</style>



// WEBPACK FOOTER //
// src/components/pages/print/PageToPrint.vue